import { Chat } from '@phosphor-icons/react/dist/ssr';
import classNames from 'classnames';

import { useComponentContext } from '../context/useComponentContext';

import { actionText } from '../PostCommentsFeed.css';

interface Props {
  onClick: () => void;
  subCommentsCount: number;
}

const CommentReplyAction = ({ subCommentsCount, onClick }: Props) => {
  const { translations } = useComponentContext();

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(actionText, 'flex flex-row gap-x-1 leading-4 items-center uppercase')}
    >
      <Chat className="h-4 w-4 text-current" />
      <span>
        {translations?.['comments.replying.reply']}
        {subCommentsCount !== 0 && `(${subCommentsCount})`}
      </span>
    </button>
  );
};

export default CommentReplyAction;
